import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/MainForm.css'

const LanguageSelector = ({ onChangeLanguage }) => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const handleChangeLanguage = (e) => {
    const newLanguage = e.target.value;
    setSelectedLanguage(newLanguage);
    onChangeLanguage(newLanguage);
  };

  return (
    <>
    <select className='languageSelector' value={selectedLanguage} onChange={handleChangeLanguage}>
      <option value="es">Español</option>
      <option value="en">English</option>
    </select>
    </>
  );
};

export default LanguageSelector;
